import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    XtremePushBannerButton,
    XtremePushBannerDisclaimer,
    XtremePushBannerHeader,
    XtremePushBannerHeaderWrapper,
    XtremePushBannerIcon,
    XtremePushBannerTitleWrapper,
    XtremePushBonusContainer,
} from './XtremePushBanner.style';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export type XtremePushBannerTypes = 'casino' | 'sportsbook';

interface XtremePushBannerPropsType {
    type: XtremePushBannerTypes;
}

export const XtremePushBanner = observer('XtremePushBanner', (props: XtremePushBannerPropsType) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { xtremePushState } = appLayoutsState;
    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = ConfigComponents.get(common).unifiedComponentConfig;
    return (
        <XtremePushBonusContainer>
            <XtremePushBannerHeaderWrapper>
                <XtremePushBannerIcon />
                <XtremePushBannerTitleWrapper>
                    <XtremePushBannerHeader>Try your luck for free rewards!</XtremePushBannerHeader>
                    <XtremePushBannerDisclaimer>Ts&Cs apply</XtremePushBannerDisclaimer>
                </XtremePushBannerTitleWrapper>
            </XtremePushBannerHeaderWrapper>
            <XtremePushBannerButton
                onClick={(): void => xtremePushState.startGame(props.type)}
                appearance='secondary'
                size={unifiedSportEventsTable ? 'small' : 'medium'}
                variant={sportsbookVariant}
            >
                Play For Free
            </XtremePushBannerButton>
        </XtremePushBonusContainer>
    );
});
